import { Link } from "@tanstack/react-router";
import { CreditCard } from "lucide-react";
import { useTranslations } from "use-intl";

import { Button } from "@lawline/ui/components/button";

import { useAuth } from "@platform/auth/context";

// Shown in place on tenant-scoped pages when the active tenant has no billing
// set up. Billing managers get a CTA to set it up; everyone else is told to
// contact the owner.
export function BillingNotSetUpNotice() {
	const t = useTranslations("common.errors.billingNotSetUp");
	const { can } = useAuth();
	const canManage = can({ billing: ["manage"] });

	return (
		<div className="flex h-full items-center justify-center">
			<div className="flex max-w-md flex-col items-center gap-3 text-center">
				<div className="flex size-12 items-center justify-center">
					<CreditCard className="text-muted-foreground size-6" />
				</div>
				<h1 className="text-lg font-semibold">{t("heading")}</h1>
				<p className="text-muted-foreground text-sm">
					{canManage ? t("ownerMessage") : t("message")}
				</p>
				{canManage && (
					<Button asChild size="sm">
						<Link to="/billing">{t("action")}</Link>
					</Button>
				)}
			</div>
		</div>
	);
}
